<template>
  <section>
    <div class="form-half pd-t">
      <el-form
        ref="form"
        :rules="rules"
        :model="formData">
        <div class="form-item mg-b-15">
          <span>How many pets need to have coverage?</span>
          <el-form-item
            ref="no_of_pet"
            :rules="rules.select"
            prop="no_of_pet">
            <v-radio-group
              v-model="formData.no_of_pet"
              :button="true"
              :list="petNumOptions"
              @change="handlePetCount"
            />
          </el-form-item>
        </div>
        <div
          v-for="(item,index) in formData.pet_info"
          :key="index"
          class="box">
          <span class="color-dark pet-title">Pet {{index+1}}</span>
          <div class="form-item">
            <span>Species</span>
            <el-form-item
              :ref="`pet_info.${index}.type_of_pet`"
              :rules="rules.select"
              :prop="`pet_info.${index}.type_of_pet`">
              <v-radio-group
                v-model="item.type_of_pet"
                block
                :list="localAllOptions.type_of_pet"
              />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Breed</span>
            <el-form-item
              :ref="`pet_info.${index}.breed_id`"
              :rules="rules.select"
              :prop="`pet_info.${index}.breed_id`">
              <v-select
                v-model="item.breed_id"
                :list="breedList(item.type_of_pet)"
              />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Age</span>
            <el-form-item
              :ref="`pet_info.${index}.age`"
              :prop="`pet_info.${index}.age`"
              :rules="rules.select">
              <v-select
                v-model="item.age"
                :list="localAllOptions.pet_ages" />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'

export default {
  name: 'petUnderwriting',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      pet: {
        type_of_pet:'',
        breed_id:'',
        age:'',
      },
      formData: {
        no_of_pet:1,
        pet_info:[
          {
            type_of_pet:'',
            breed_id:'',
            age:'',
          }
        ]
      },
    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions31||{}
    },
    breedList(){
      return (type_of_pet)=>{
        let {cat_breeds,dog_breeds } = this.localAllOptions||{}
        if(type_of_pet==1){
          return cat_breeds||[]
        }
        else {
          return dog_breeds||[]
        }
      }
    }
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        Object.keys(this.formData).some(key => {
          if (key in val) {
            this.formData[key] = val[key]
          }
        })
      }
    },
  },
  methods: {
    handlePetCount(){
      let {no_of_pet,pet_info} = this.formData||{}
      if(pet_info.length<no_of_pet){
        for(var i= pet_info.length;i<no_of_pet;i++){
          let objData = JSON.parse(JSON.stringify(this.pet))
          pet_info.push(objData)
        }
      }else {
        pet_info.splice(no_of_pet,pet_info.length)
      }
    },
    submitForm() {
      // 表單校驗
      this.$refs.form.validate(valid => {
        if(valid) {
          let params = {
            ...this.formData,
            class_id: 31
          }
          this.$emit('getFormData', params)
        }
      })

    }
  }
}
</script>

<style scoped lang="scss">
  .box{
    border-top: 1px solid #D1D5DA;
    padding: 30px 0 ;
    .pet-title{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      display: block;
      margin-bottom: 30px;
    }
  }
</style>
